module.exports = __webpack_public_path__ + "img/step1.77e6637f.png";